<template>
    <div>
        <form id="card_to_card_settings_form" v-if="setting_status != 'loading'">
            <kt-row>
                <kt-col xs="6">
                    <div v-for="(card_setting , index) in setting">
                        <div class="container p-3 pt-5 my-4 border in-border-header">
                            <div class="section-header">
                                {{ card_setting.card_number }}
                            </div>
                            <kt-col xs="12">
                                <kt-form-group>
                                    <div class="custom-control custom-switch">
                                        <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            :id="'is_count_limited'+index"
                                            :name="'is_count_limited'+index"
                                            v-model="card_setting.is_count_limited"
                                        >
                                        <label class="custom-control-label" :for="'is_count_limited'+index">{{
                                                $t('card_to_card.is_count_limited')
                                            }}</label>
                                    </div>
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" v-if="card_setting.is_count_limited">
                                <kt-form-group>
                                    <kt-form-label for="count_limit">
                                        {{ $t('card_to_card.count_limit') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        :id="'count_limit'+index"
                                        type="number"
                                        :name="'count_limit'+index"
                                        v-model="card_setting.count_limit"
                                        dir="ltr"
                                    >
                                    </kt-form-control>
                                    <p :id="'count_limit_error'+index"
                                       style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" style="margin-top: 35px">
                                <kt-form-group>
                                    <div class="custom-control custom-switch">
                                        <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            :id="'is_amount_limited'+index"
                                            :name="'is_amount_limited'+index"
                                            v-model="card_setting.is_amount_limited"
                                        >
                                        <label class="custom-control-label" :for="'is_amount_limited'+index">{{
                                                $t('card_to_card.is_amount_limited')
                                            }}</label>
                                    </div>
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" v-if="card_setting.is_amount_limited">
                                <kt-form-group>
                                    <kt-form-label for="amount_limit">
                                        {{ $t('card_to_card.amount_limit') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        :id="'amount_limit'+index"
                                        type="number"
                                        :name="'amount_limit'+index"
                                        v-model="card_setting.amount_limit"
                                        dir="ltr"
                                    >
                                    </kt-form-control>
                                    <p :id="'amount_limit_error'+index"
                                       style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                                </kt-form-group>
                            </kt-col>
                        </div>
                    </div>
                </kt-col>
                <kt-col xs="6">
                    <div class="container p-3 pt-5 my-4 border in-border-header">
                        <div class="section-header">
                            {{ $t('card_to_card.card_prioritize') }}
                        </div>
                        <kt-col xs="12" v-for="(priority, index) in priorities" :key="index">
                            <kt-form-group v-if="index != 0">
                                <kt-form-label>
                                    {{ $t('label.priority') + (index) }}
                                </kt-form-label>
                                <kt-form-select
                                    size="3"
                                    :id="'priority'+index"
                                    :name="'priority'+index"
                                    v-model="priorities[index]"
                                >
                                    <option
                                        v-bind:key="index"
                                        v-for="(card, index) in setting"
                                        v-bind:value="card.card_number"
                                    >
                                        {{ card.card_number }}
                                    </option>
                                </kt-form-select>
                                <p :id="'priority_error'+index"
                                   style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                            </kt-form-group>
                        </kt-col>
                    </div>
                </kt-col>
                <kt-col xs="12" style="text-align: end">
                    <kt-form-action class="mt-4">
                        <kt-button
                            class="m-2"
                            size="md"
                            variant="success"
                            type="button"
                            @click="edit"
                            v-bind:wide="true"
                            id="card_to_card_settings_btn"
                        >
                            {{ $t('btn.edit') }}
                        </kt-button>
                    </kt-form-action>
                </kt-col>
            </kt-row>
        </form>
    </div>
</template>

<script>
import $ from "jquery";
import {KTApp} from '@/plugins/core/app'
import {KTUtil} from '@/plugins/core/util';
import {mapGetters} from 'vuex'
import {cardToCardService} from '@/common/api.service'
import {i18n} from '@/plugins/i18n'


export default {
    components: {},
    data() {
        return {
            priority_count: 0,
            priorities: [],
        }
    },
    methods: {
        edit() {
            let btn = $('#card_to_card_settings_btn')
            let form = $('#card_to_card_settings_form')

            let has_error = false
            for (let i = 0; i < this.setting.length; i++) {
                if (this.setting[i].is_count_limited) {
                    if (!this.setting[i].count_limit) {
                        document.getElementById('count_limit_error' + i).innerText = i18n.t('card_to_card.message.fill')
                        document.getElementById('count_limit' + i).style.borderColor = '#fd397a'
                        has_error = true;
                    } else {
                        document.getElementById('count_limit_error' + i).innerText = ''
                        document.getElementById('count_limit' + i).style.borderColor = '#e2e5ec'
                    }
                }
                if (this.setting[i].is_amount_limited) {
                    if (!this.setting[i].amount_limit) {
                        document.getElementById('amount_limit_error' + i).innerText = i18n.t('card_to_card.message.fill')
                        document.getElementById('amount_limit' + i).style.borderColor = '#fd397a'
                        has_error = true;
                    } else {
                        document.getElementById('amount_limit_error' + i).innerText = ''
                        document.getElementById('amount_limit' + i).style.borderColor = '#e2e5ec'
                    }
                }
            }

            for (let i = 1; i < this.priorities.length; i++) {
                if (!this.priorities[i]) {
                    document.getElementById('priority_error' + i).innerText = i18n.t('card_to_card.message.fill')
                    document.getElementById('priority' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    let duplicate_priority = false
                    for (let j = 1; j < this.priorities.length; j++) {
                        if (this.priorities[i] == this.priorities[j] && j != i) {
                            duplicate_priority = true;
                            break;
                        }
                    }
                    if (duplicate_priority) {
                        document.getElementById('priority_error' + i).innerText = i18n.t('card_to_card.message.duplicate_priority')
                        document.getElementById('priority' + i).style.borderColor = '#fd397a'
                    } else {
                        document.getElementById('priority_error' + i).innerText = ''
                        document.getElementById('priority' + i).style.borderColor = '#e2e5ec'
                    }
                }
            }
            if (has_error)
                return;
            for (let i = 0; i < this.setting.length; i++) {
                for (let j = 1; j < this.priorities.length; j++) {
                    if (this.setting[i].card_number == this.priorities[j]) {
                        this.setting[i].priority = j;
                    }
                }
            }
            KTApp.progress(btn)
            let params = {
                cards_setting: this.setting
            }

            if (this.$can('manage', 'card-to-card')) {
                cardToCardService.adminUpdateSetting(params, this.$route.params.hashid).then(response => {
                    this.showMsg(form, 'success', response.data.message);
                }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message);
                }).finally(response => {
                    KTUtil.scrollTop();
                    KTApp.unprogress(btn)
                })
            } else {
                cardToCardService.updateSetting(params, this.$route.params.hashid).then(response => {
                    this.showMsg(form, 'success', response.data.message);
                }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message);
                }).finally(response => {
                    KTUtil.scrollTop();
                    KTApp.unprogress(btn)
                })
            }
        },
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        setPriorities() {
            this.priority_count = this.setting.length
            let priorities = []
            priorities[0] = null

            for (let i = 1; i <= this.priority_count; i++) {
                for (let j = 0; j < this.priority_count; j++) {
                    priorities[i] = null
                    if (this.setting[j].priority == i) {
                        priorities[i] = this.setting[j].card_number
                        break;
                    }
                }
            }
            this.priorities = priorities
        }
    },
    computed: {
        ...mapGetters('cardToCard', [
            'setting', 'setting_status'
        ]),
    },
    watch: {
        setting_status: {
            handler(newValue, oldValue) {
                if (newValue == 'success')
                    this.setPriorities()
            },

        },
    },
    mounted() {
        if (this.$can('manage', 'card-to-card')) {
            this.$store.dispatch('cardToCard/adminFetchSetting', this.$route.params.hashid, true)
        } else
            this.$store.dispatch('cardToCard/fetchSetting', this.$route.params.hashid, true)

        this.afterDispatch()
    }
}
</script>

<style>

</style>